import { createSelector } from 'reselect';

import { State } from '../types';
import { supportedLanguagesLocal } from '@wetransfer/transfer/init/locale';

export const selectSession = (state: State): State['session'] => state.session;

export const getSessionLanguage = createSelector(
  selectSession,
  (session) => session.language
);

export const selectCountryCode = createSelector(
  selectSession,
  (session) => session.region.country
);

export const selectDomainUserId = createSelector(
  selectSession,
  (session) => session.domainUserId
);

export const isLanguageEnglish = createSelector(
  getSessionLanguage,
  (sessionLanguage) => sessionLanguage === supportedLanguagesLocal.ENGLISH
);

export const selectIsSessionTandC = createSelector(
  selectSession,
  (session) => session.tandc
);
